export enum ThreatKey{
	UNAUTHORIZED_ACCESS = 'UNAUTHORIZED_ACCESS',
	UNAUTHORIZED_DISCLOSURE = 'UNAUTHORIZED_DISCLOSURE',
	UNAUTHORIZED_UPDATE = 'UNAUTHORIZED_UPDATE',
	LOSS = 'LOSS',
	ACCIDENTAL_OR_ILLEGAL_DESTRUCTION = 'ACCIDENTAL_OR_ILLEGAL_DESTRUCTION',
	IMPROPER_USE = 'IMPROPER_USE',
}
